export default "__VITE_ASSET__pzx6K7$G__"